import { FormContainer as Container, FormSection as Section } from "../../components/index.js";
import { InputField as Input, RowField as Row } from "../../components/index.js";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import FormContext from "../../context/FormContext.js";
import { useContext, useEffect, useState } from 'react';
import StaticDataContext from "../../context/StaticDataContext.js";

export default function BusRegistration() {
    const { injectFormProps } = useInjectFormProps();
    const { formData } = useContext(FormContext);

    const { staticData } = useContext(StaticDataContext);

    const [gradeLabel, setGradeLabel] = useState("");
    const [age, setAge] = useState("");


    useEffect(() => {
        const gradeInfo = staticData["gradeLevels"].find(
            (item) => item.Code === formData["grade"]
        );

        if (gradeInfo) {
            setGradeLabel(gradeInfo.Description);
        }
    }, [formData["grade"]]);

    useEffect(() => {
        if (formData["dateOfBirth"]) {
            setAge(() => {
                const today = new Date();
                const birthDate = new Date(formData['dateOfBirth']);
                let stuAge = today.getFullYear() - birthDate.getFullYear();
                const hasHadBirthdayThisYear =
                    today.getMonth() > birthDate.getMonth() ||
                    (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

                if (!hasHadBirthdayThisYear) {
                    stuAge--;
                }

                return stuAge;
            })
        }
    }, [formData["dateOfBirth"]])

    return (
        <Container>
            {injectFormProps(
                <>
                    <Section title={"School Bus Student Registration"}>
                        <i style={{ textAlign: "center" }}>
                            Certain information below has been pre-populated. Please review previous pages if you identify any errors.
                        </i>
                        <b style={{ fontSize: "1.2rem" }}>Student Information</b>
                        <Input type={"text"} disabled inputLabel={"Student Name"} 
                        value={formData["studentFirstName"] ? formData["studentFirstName"] + " " 
                        + formData["studentLastName"] + " " 
                        + formData["studentLegalSuffix"]: ""} mandatory={false}></Input>
                        <Row>
                            <Input type={"text"} disabled inputLabel={"Age"} value={age} mandatory={false}></Input>
                            <Input type={"text"} disabled inputLabel={"Grade"} value={gradeLabel} mandatory={false}></Input>
                            <Input type={"text"} disabled inputLabel={"School"} value={formData["schoolReceiving"] ? formData["schoolReceiving"] : ""} mandatory={false}></Input>
                        </Row>
                        <b style={{ fontSize: "1.2rem" }}>Bus Contacts</b>
                        <Container>
                            <i>The contacts below have been selected as bus contacts because they were marked as Priority 1 and 2 in the section Student Contacts.</i>
                            <p></p>
                            {!formData.studentContacts ?
                                <b><i>No contacts available. Please check "Student Contacts" page.</i></b> :
                                formData.studentContacts
                                    .filter((contact) => formData[`contactPriority-` + contact.key] === "1" || formData[`contactPriority-` + contact.key] === "2")
                                    .map((contact) => (
                                        <div key={contact.key}>
                                            Emergency contact {formData[`contactPriority-` + contact.key]}: 
                                            <b>
                                                {`
                                                ${formData[`contactFirstName-` + contact.key] ? formData[`contactFirstName-` + contact.key] : ""} 
                                                ${formData[`contactLastName-` + contact.key] ? formData[`contactLastName-` + contact.key] : ""}
                                                ${formData[`contactLegalSuffix-` + contact.key] ? formData[`contactLegalSuffix-` + contact.key] : ""}
                                                `}
                                            </b>
                                        </div>
                                    ))
                            }
                        </Container>
                        <hr />
                        <Input type={"text"} inputLabel={"Please list any health or other concerns of which the driver should be aware:"}
                            mandatory={false} identifier={"busHealthConcerns"}></Input>
                        <Input type={"date"} inputLabel={"Requested date for bussing"} identifier={"busRequestDate"} ></Input>
                        <hr />
                        <b><i>DURING THE SCHOOL YEAR, TRANSPORTION WILL BE ARRANGED WITHIN 3 BUSINESS DAYS UPON RECEIPT OF THIS FORM
                        </i></b>
                        <br />
                        <Input type={"checkbox"} inputLabel={"I confirm that all the above information is correct and accurate."} identifier={"busRegConfirm"}></Input>
                    </Section >
                </>
            )
            }
        </Container >
    );
}
